import { Truck, CreditCard, PackageCheck, Clock } from 'lucide-react';

export default function Delivery() {
  return (
    <div className="min-h-screen bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-bold text-center mb-12" style={{ fontFamily: 'Cormorant Garamond, serif' }} data-testid="delivery-title">
          Доставка и оплата
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center mr-4">
                <Truck className="w-6 h-6 text-sky-600" />
              </div>
              <h2 className="text-2xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Условия доставки</h2>
            </div>
            <div className="space-y-4 text-gray-600">
              <div className="flex items-start">
                <div className="w-2 h-2 bg-sky-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                <p><strong>Москва и МО:</strong> Бесплатная доставка при заказе от 10 000 ₽. При заказе от 5 000 ₽ - 500 ₽</p>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-sky-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                <p><strong>Регионы:</strong> Доставка транспортными компаниями. Стоимость рассчитывается индивидуально</p>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-sky-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                <p><strong>Время доставки:</strong> Сегодня или в удобное для вас время</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-cyan-100 rounded-full flex items-center justify-center mr-4">
                <PackageCheck className="w-6 h-6 text-cyan-600" />
              </div>
              <h2 className="text-2xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Упаковка</h2>
            </div>
            <div className="space-y-4 text-gray-600">
              <div className="flex items-start">
                <div className="w-2 h-2 bg-cyan-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                <p>Все товары упаковываются в специальные термобоксы</p>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-cyan-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                <p>Сохранение температуры от 0 до +4°C на протяжении 24 часов</p>
              </div>
              <div className="flex items-start">
                <div className="w-2 h-2 bg-cyan-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                <p>Хладоэлементы и гелевые аккумуляторы холода</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg mb-16">
          <div className="flex items-center mb-8">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
              <CreditCard className="w-6 h-6 text-blue-600" />
            </div>
            <h2 className="text-2xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Способы оплаты</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 border-2 border-gray-200 rounded-xl hover:border-sky-500 transition-colors">
              <h3 className="font-bold text-lg mb-3">Наличными при получении</h3>
              <p className="text-gray-600">Оплата курьеру наличными или картой при получении заказа</p>
            </div>
            <div className="p-6 border-2 border-gray-200 rounded-xl hover:border-sky-500 transition-colors">
              <h3 className="font-bold text-lg mb-3">Онлайн-оплата</h3>
              <p className="text-gray-600">Оплата банковской картой на сайте (безопасный платёжный шлюз)</p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-sky-600 to-cyan-600 rounded-2xl p-12 text-white">
          <div className="flex items-center justify-center mb-6">
            <Clock className="w-12 h-12 mr-4" />
            <h2 className="text-3xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>График работы</h2>
          </div>
          <div className="text-center">
            <p className="text-xl mb-2">Приём заказов: <strong>ежедневно с 9:00 до 21:00</strong></p>
            <p className="text-lg text-white/90">Доставка: ежедневно с 10:00 до 22:00</p>
          </div>
        </div>
      </div>
    </div>
  );
}